export default __webpack_public_path__ + "static/alfred_search_url-c5c8ee4a51e45ff9f031afd8c6a388a1.png";